<template>
  <TopNav></TopNav>
  <h1>Compound Interest Calculator</h1>
  <fieldset>
    <legend>Compound Interest Calculator</legend>
    <label for="a">Principal:</label><input type="number" v-model.number="anapara" id="a" step="any" min="0"> $
    <br>
    <label for="b">Annual Rate:</label><input type="number" v-model.number="faizOrani" id="b" step="any" min="0"> %
    <br>
    <label for="b">Time:</label><input type="number" v-model.number="vade" id="b" step="any" min="0"> years
    <br>
    <label for="b">Compound:</label>
    <select name="frequency">
      <option value="annual">Annual</option>
    </select>
    <br><br>
    Principal with {{ formatliAnapara() }} $ and {{ faizOrani }}% interest rate will be <span class="blue">${{ sonuc() }}</span> after {{ vade }} years.
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: 'CompoundInterest',
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2
      }),
      anapara: 1000,
      faizOrani: 5,
      vade: 5,
    }
  },
  components: {
    TopNav
  },
  methods: {
    sonuc: function () {
      let oran = (1 + this.faizOrani / 100);
      let sonuc = this.anapara *  Math.pow(oran, this.vade);
      let sonucNumber = Number(sonuc);
      return this.formatter.format(sonucNumber);
    },
    formatliAnapara() {
      let anaparaNumber = Number(this.anapara);
      return this.formatter.format(anaparaNumber);
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 130px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
